'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import {
  clickEvent,
  selfServiceViewScreenEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { EnsureBalanceActivated } from '@marketplace-web/balance-activation/balance-activation-feature'

import ViewDeliveryInstructionsModal from '../ViewDeliveryInstructionsModal'

type Props = ConversationActionProps

const ViewDeliveryInstructions = ({ action, primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const transactionStatus = conversation?.transaction?.status
  const shipmentId = conversation?.transaction?.shipment?.id
  const shipmentStatus = conversation?.transaction?.shipment?.status

  const [isModalOpen, setIsModalOpen] = useState(false)

  const trackButtonClick = () => {
    const targetDetails = {
      transaction_id: transactionId,
      transaction_status: transactionStatus,
      shipment_id: shipmentId,
      shipment_status: shipmentStatus,
    }

    track(
      clickEvent({
        target: 'view_delivery_instructions',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const trackModalScreen = () => {
    if (!transactionId) return

    track(
      selfServiceViewScreenEvent({
        screen: 'delivery_instructions',
        transactionId,
      }),
    )
  }

  const handleModalOpen = () => {
    trackButtonClick()
    trackModalScreen()

    setIsModalOpen(true)
  }

  const handleModalClose = () => setIsModalOpen(false)

  if (!transactionId) return null

  return (
    <EnsureBalanceActivated
      action={action}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onSuccess={handleModalOpen}
      title={title}
    >
      <>
        <ConversationActionButton
          text={title}
          primary={primary}
          size={size}
          theme={theme}
          inverse={inverse}
          onClick={handleModalOpen}
          testId="conversation-actions-view-delivery-instructions"
        />
        <ViewDeliveryInstructionsModal isOpen={isModalOpen} onClose={handleModalClose} />
      </>
    </EnsureBalanceActivated>
  )
}

export default ViewDeliveryInstructions
